import RefreshIco from '../components/RefreshIco';
import Installation from '../models/Installation';

export const ViewMixin = {
    data() {
        return {
            loading: 0,
        };
    },
    components: { RefreshIco },
    mounted() {
        this.$onInstance('sendInstruction', this.sendInstruction);
        this.$onInstance('endInstruction', this.endInstruction);

        this.$onInstance('suscribe', this.suscribe);
        this.$onInstance('unsubscribe', this.unsubscribe);

        this.$mqtt.subscribe(`usr/${this.$session.getClientId()}/feedback`, (data) => {
            this.$emitInstance(`reciveInstruction_${data.orderId}`, data);
        });
    },
    destroyed() {
        this.$mqtt.unsubscribe(`usr/${this.$session.getClientId()}/feedback`);
    },
    methods: {
        sendInstruction: function() {
            this.loading++;
        },

        endInstruction: function() {
            this.loading--;
        },

        suscribe: function(ref, key) {
            if (!this.$mqtt.isSubscribe(key)) {
                this.$mqtt.subscribe(key, (message) => {
                    this.$store.commit('update', {
                        [ref]: new Installation(JSON.parse(message.value.slice(0, -1))),
                    });
                    this.$emitInstance(`reciveStatus_${ref}`);
                });
            }
        },

        unsubscribe: function(key) {
            if (this.$mqtt.isSubscribe(key)) this.$mqtt.unsubscribe(key);
        },
    },
};
